import styled, { css } from 'styled-components';

export const AuthPageBackgroundImage = styled.div`
  width: 100%;
  height: 100vh;
  background-image: url(${({ theme }) => theme.auth.backgroundImage});
  background-size: cover;
`;

export const AuthPageGradient = styled.div`
  position: absolute;
  bottom: 0;
  height: 200px;
  width: 100%;
  background: ${({ theme }) => theme.auth.backgroundGradient};
`;

export const AuthContainer = styled.div`
  background: ${({ theme }) => theme.auth.background};
  box-shadow: 0px 2px 8px 0px rgba(11, 18, 30, 0.08);
  width: 460px;
  border-radius: 24px;
  position: absolute;
  top: 15%;
  right: 10%;
  padding: 30px 60px;
  text-align: center;

  @media (max-width: 1024px) {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
  }

  @media (max-width: 460px) {
    width: 90%;
    padding: 40px 20px;
  }

  ${({ isSignUpPage }) =>
    isSignUpPage &&
    css`
      width: 470px;
    `}
`;

export const Heading = styled.h2`
  color: ${({ theme }) => theme.auth.heading};
  margin-bottom: 20px;
`;

export const Icon = styled.i.attrs(({ icon }) => ({ className: icon }))`
  margin-left: 15px;
  position: absolute;
  margin-top: 15px;
`;

export const InputContainer = styled.div`
  position: relative;
  color: ${({ theme }) => theme.auth.form.color};
  margin-top: 20px;

  ${({ hasError }) =>
    hasError &&
    css`
      color: ${({ theme }) => theme.auth.form.errorColor};
    `}
`;

export const InputField = styled.input`
  width: 100%;
  padding: 12px 14px 12px 40px;
  height: 45px;
  border-radius: 10px;
  border: 2px solid ${({ theme }) => theme.auth.form.border};
  background: ${({ theme }) => theme.auth.form.background};
  color: ${({ theme }) => theme.auth.form.color};

  &:focus {
    outline: none;
  }

  ${({ hasError }) =>
    hasError &&
    css`
      border: 2px solid ${({ theme }) => theme.auth.form.errorColor};
      color: ${({ theme }) => theme.auth.form.errorColor};
    `}
`;

export const InfoText = styled.div`
  font-size: 14px;
  margin-top: 20px;
  padding: 12px 30px 12px 30px;
  border-radius: 12px;

  ${({ error }) =>
    error &&
    css`
      background: ${({ theme }) => theme.auth.form.errorBackgroundColor};
      color: ${({ theme }) => theme.auth.form.errorColor};
    `}

  ${({ success }) =>
    success &&
    css`
      background: ${({ theme }) => theme.auth.form.successBackgroundColor};
      color: ${({ theme }) => theme.auth.form.successColor};
    `}
`;

export const LinkToPage = styled.div`
  color: ${({ theme }) => theme.auth.form.linkColor};
  cursor: pointer;
  text-decoration: underline;
  margin-top: 20px;
`;

export const TextContainer = styled.div`
  color: ${({ theme }) => theme.auth.form.color};
  margin-top: 20px;

  ${({ error }) =>
    error &&
    css`
      color: ${({ theme }) => theme.auth.form.errorColor};
    `}

  ${({ success }) =>
    success &&
    css`
      color: ${({ theme }) => theme.auth.form.verifiedColor};
    `}
`;

export const Label = styled.div`
  color: ${({ theme }) => theme.auth.form.color};
  text-align: left;
  margin-top: 15px;
`;
